var ChooseJobBoardCredentialTypeModalController = /** @class */ (function () {
    function ChooseJobBoardCredentialTypeModalController() {
        // this.addJobBoardByPasswordFlag = this.resolve.addJobBoardByPasswordFlag;
    }
    ChooseJobBoardCredentialTypeModalController.prototype.$onInit = function () {
        this.addJobBoardByPasswordFlag = this.resolve.addJobBoardByPasswordFlag;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    ChooseJobBoardCredentialTypeModalController.prototype.onTypeSelected = function () {
        this.callbackObject = { callbackType: 'typeChange', entity: { addJobBoardByPasswordFlag: this.addJobBoardByPasswordFlag } };
        this.closeModal();
    };
    ChooseJobBoardCredentialTypeModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    ChooseJobBoardCredentialTypeModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return ChooseJobBoardCredentialTypeModalController;
}());
// import * as TEMPLATE from './choose-job-board-credential-type-modal.html';
import * as TEMPLATE from 'raw-loader!./choose-job-board-credential-type-modal.html';
export var ChooseJobBoardCredentialTypeModalComponent = {
    selector: 'chooseJobBoardCredentialTypeModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ChooseJobBoardCredentialTypeModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/chooseJobBoardCredentialTypeModal/choose-job-board-credential-type-modal.html'
    }
};
//# sourceMappingURL=choose-job-board-credential-type-modal.component.js.map